/**
 * <ProfileBadge />
 *
 * When profile has .img, we display the image, if not, we display 
 * it's initial. It's colour is determined by the initial as well.
 *
 * @parent anybody
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Tooltip from 'react-tooltip';
import './ProfileBadge.scss';
import uniqid from 'uniqid';

const DEFAULT_TYPE = 'small';

class ProfileBadge extends React.Component {
  static propTypes = {
    type: PropTypes.string, // small, medium
    profiles: PropTypes.array.isRequired,
    // components
  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    const {
      profiles,
      type = DEFAULT_TYPE,
    } = this.props;

    return (
      <div className={classnames('profile-badge', type)}>
        {profiles.map((profile, key)=>{
          const id = 'profile-name-' + uniqid(); 
          if (profile.img) {
          return (<div key={key} data-tip data-for={id} className='badge badge-image' style={{ backgroundImage: profile.img, }}>
            <Tooltip 
              id={id} 
              effect='solid' 
              place='top'
              type='info'
              getContent={()=> { return profile.name; }}
            />
          </div>)
          } else {
          return (<div key={key} data-tip data-for={id} className='badge badge-initial'>{profile.name[0]}
            <Tooltip 
              id={id} 
              effect='solid' 
              place='top'
              type='info'
              getContent={()=> { return profile.name; }}
            />
          </div>)
          }
        })} 
      </div>
    )
  }
}

export default ProfileBadge;



// WEBPACK FOOTER //
// ./src/components/UI/ProfileBadge/index.js